var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorosidadBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 25.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efb928;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,12.16h-.44c-.19-.32-.54-.52-.93-.52h-3.9V1.08c0-.6-.49-1.08-1.08-1.08H6.35c-.6,0-1.08.49-1.08,1.08v10.56H1.36c-.29,0-.56.12-.76.32-.06.06-.11.13-.16.2h-.44l.31.31c-.02.08-.03.17-.03.26,0,.29.11.55.32.76l11.64,11.64c.2.21.48.32.77.32s.56-.11.77-.32l11.64-11.64c.27-.27.38-.66.29-1.02l.31-.31ZM7.43,12.72V2.17h11.13v10.55c0,.6.49,1.08,1.08,1.08h2.37l-9.02,9.02L3.98,13.81h2.37c.6,0,1.08-.49,1.08-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.69,11.95v.66c-.03.62.28,1.2.84,1.52.42.21.89.31,1.35.29h.25v1.12h1.75v-1.12h.25c1.2,0,2.19-.99,2.19-2.19v-.62c0-1.2-.99-2.19-2.19-2.19h-.25v-1.5h.25c.24,0,.44.2.44.44v.68h1.75v-.68c0-1.2-.99-2.19-2.19-2.19h-.25v-1.12h-1.75v1.12h-.25c-1.2,0-2.19.99-2.19,2.19v.62c0,1.2.99,2.19,2.19,2.19h.25v1.5h-.25c-.29,0-.41-.03-.44-.04v-.67h-1.75ZM12.13,7.9v1.51h-.25c-.24,0-.44-.2-.44-.44v-.62c0-.24.2-.44.44-.44h.25ZM13.87,12.66v-1.5h.25c.24,0,.44.2.44.44v.62c0,.24-.2.44-.44.44h-.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorosidadBalken);
export default __webpack_public_path__ + "static/media/morosidad_BALKEN.532380020ba72d12ed2245e7a79b7f5a.svg";
export { ForwardRef as ReactComponent };